import { configureStore } from "@reduxjs/toolkit";
import companiesReducer from "./features/companiesSlice";
import companyDetailReducer from "./features/companyDetailSlice";

export const store = configureStore({
  reducer: {
    companies: companiesReducer,
    companyDetail: companyDetailReducer,
  },
});
